const masterTableFields = [
  {title: "Ref Id",
      is_searchable: false,
      class_name: 'w-110p',
      field: {
          name: "id"
      },
      fetch_key: "id"
  },
  {title: "Email",
      is_searchable: true,
      class_name: 'w-200p',
      field: {
          type: "text",
          name: "email"
      },
      fetch_key: "email.email"
  },
  {title: "Name-Address",
      is_searchable: false,
      class_name: 'w-auto',
      field: {
          name: "name_address"
      },
      fetch_key: "nomination.name_address"
  },
  {title: "Created Date",
      is_searchable: false,
      class_name: 'w-125p',
      field: {
          name: "created_at"
      },
      fetch_key: "created_at"
  }
];
//View Form Data
const fieldNomiView1 = [
  {label: "Email", type: "object", value_key: "email.email"},
  {label: "Name of your academic institution and address", type: "object", value_key: "nomination.name_address"},
  {label: "Which of the following syllabi are offered to students in your school currently?", type: "array", value_key: "board_details", array_key: "label"},
  {label: "Are you nominating IFSPD Europe Future Global Leaders Fellowship in one school or in a group of schools?", type: "object", value_key: "nominating_type"},
  {label: "How many schools in your group are you nominating?", type: "string", value_key: "school_count"},
  {label: "How many students are there totally in your school?", type: "object", value_key: "nomination.student_count"},
  // {label: "Which month does your school academic calendar start and which month does it end?", type: "object", value_key: "start_end_month"},
  {label: "School Type", type: "object", value_key: "nomination.school_type_details.type"}
];

const fieldNomiView2 = [
  {label: "What selection criteria and enrollment strategies will your school implement to ensure the successful shortlisting and enrollment of at least 150 students into the IFSPD Europe Future Global Leaders Fellowship?", type: "object", value_key: "nomination.selection_criteria"},
  {label: "Are you officially affiliated with any other international institutions connected to the United Nations?", type: "string", value_key: "is_affi_internationally"},
  {label: "Name of the international organisation", type: "object", value_key: "nomination.organisation_name"}];

const fieldNomiView3 = [
  {label: "Contact details along with mobile number of the Principal of your school.", type: "object", value_key: "nomination.principal_contact"},
  {label: "Contact details along with mobile number of a single point of contact from your school, who will coordinate the roll out and management of IFSPD Europe Future Global Leaders Fellowship (please nominate someone other than the Principal).", type: "object", value_key: "nomination.nominated_contact"}];

const data = {
  masterTableFields,
  fieldNomiView1,
  fieldNomiView2,
  fieldNomiView3
};

export default data;